import { useMemo } from 'react';
import { previewComponents } from '../preview_component_mapping';
const NullComponent = () => null;
export const usePreviewComponent = (previewOptions, fallback = NullComponent) => {
    const previewId = previewOptions === null || previewOptions === void 0 ? void 0 : previewOptions.id;
    return useMemo(() => {
        var _a;
        return previewId ? ((_a = previewComponents[previewId]) !== null && _a !== void 0 ? _a : fallback) : fallback;
    }, [previewId]);
};
//# sourceMappingURL=use_preview_component.js.map